'use client';

import { APP_ROUTE } from '@src/constants/routes';
import { useRouter } from 'next/navigation';
import React from 'react';
import Error404WithSVG from '@src/v3/components/errorCommonModule/error404WithSVG';
import Header from '@src/v3/components/header';

function NotFound() {
  const { push } = useRouter();
  return (
    <>
      <Header />
      <div className="flex justify-center items-center min-h-screen bg-white">
        <Error404WithSVG
          title="Oops! Page not found"
          buttonText="Go Home"
          onButtonClick={() => push(APP_ROUTE.HOME)}
        />
      </div>
      <div className="fixed bottom-0 text-gray-800 text-sm text-center w-full pt-10 sm:pb-[70px] pb-6">
        <span>Zeme © {new Date().getFullYear()}</span>
      </div>
    </>
  );
}

export default NotFound;
